import { Colors, Spacing } from "_styles";

export const domesticDepartures = Colors.PRM_LIGHT_BLUE;
export const internationalDepartures = '#57B0F2'
export const departures = Colors.PRM_LIGHT_BLUE;
export const arrivals = Colors.ARRIVALS_GREEN;
export const domesticArrivals = "#29C40D"
export const internationalArrivals = '#7AFA84'
export const transitBookings = 'purple'
export const completedTasks = "#29C40D"
export const rejectedTasks = 'red'
export const activeTasks = 'orange'
export const pendingTasks = "#8316f7"
export const breakTasks = "#d51d1d"
export const ALTPickUps = "#800080"
export const assignedTask = "#b0b3b5"
export const acknowledgedTasks = '#3399ff'
export const combinedBooking = '#e895a4'
export const combinedRampBooking = '#456440'
export const gateRelocationTask = "#ebb71c"


